import VendorProfile from "./VendorProfile"

export default VendorProfile